import { createFileRoute } from "@tanstack/react-router";
import { AccountPage } from "@/components/app/portal/pages/account-page";

export const Route = createFileRoute("/resident-portal/account")({
  head: () => ({ meta: [{ title: "Account | People AI" }] }),
  component: AccountPage,
});
